module.exports = __webpack_public_path__ + "img/pdfdocumentlogo.2d7c057b.png";